module.exports = __webpack_public_path__ + "static/media/chinese-snackbox.abb15941.jpg";